import Vue from 'vue'
import gql from 'graphql-tag'

const query = gql`
  query campaign ( $id: ID! ) {
    campaign ( id: $id ) {
      dueDate
      value
      peopleRegisteredCount
      registeredAmount
      peopleRegisteredOrPaidCount
      paidAmount
      paidAmountPercentage
      peoplePaidCount
      paidCountPercentage
      goalValue
      goalValuePercent
      averageAmount
    }
  }
`

/**
 * @param {*} id
**/

 async function getCampaignDataQuery( params ) {
  const { $api } = Vue.prototype
  const data = await $api.query({
    query,
    fetchPolicy: 'no-cache',
    variables: params
  }).then( res => res )
  .catch( e => e )
  return data;
}

export { getCampaignDataQuery }
